import { IconButton, Tooltip } from '@chakra-ui/react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as ShapeLabelIcon } from 'src/assets/icons/shape-label-icon.svg';
import SparkelIcon from 'src/components/common/icon/SparkelIcon';
import { useSheetViewerV2 } from 'src/components/viewers/SheetsViewerV2/hooks/useSheetViewerV2';

export default function SheetShapeLabelsButton(): React.ReactElement {
  const { showSheetShapeLabels, setShowSheetShapeLabels } = useSheetViewerV2();
  const { t } = useTranslation('project');

  const activeIconColor: [string, string] = ['teal.500', 'teal.200'];

  return (
    <Tooltip label={t('shape-labels-button')}>
      <IconButton
        aria-label="Sheet Shape Labels On/Off"
        icon={
          <SparkelIcon
            as={ShapeLabelIcon}
            color={showSheetShapeLabels ? activeIconColor : undefined}
          />
        }
        isRound
        isActive={showSheetShapeLabels}
        colorScheme={showSheetShapeLabels ? 'teal' : 'gray'}
        variant={showSheetShapeLabels ? 'toggle' : 'solid-no-transparent'}
        size="xs"
        onClick={() => setShowSheetShapeLabels(!showSheetShapeLabels)}
      />
    </Tooltip>
  );
}
